import { OutlinedInput, IconButton, InputAdornment } from "@common-ui/ui";

//Icons
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import SearchIcon from '@mui/icons-material/Search';

export const ProfileSearch = (props) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "flex-end",
                columnGap: "12px",
            }}
        >
            <OutlinedInput
                autoComplete="off"
                placeholder={props.placeholder}
                size="small"
                fullWidth
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton edge="end">
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                }
            />
            {props.showAddDomain && (
                <IconButton
                    size="small"
                    color="primary"
                    sx={{
                        border: "1px solid #BADBFF",
                        borderRadius: 2,
                    }}
                >
                    <DomainAddIcon />
                </IconButton>
            )}
            <IconButton
                size="small"
                color="primary"
                sx={{
                    border: "1px solid #BADBFF",
                    borderRadius: 2,
                }}
            >
                <AddLocationAltIcon />
            </IconButton>
        </div>
    );
}

ProfileSearch.defaultProps = {
    placeholder: "Search",
    showAddDomain: true
}